import { AttachmentType } from '../fixedops/attachment';
import { Template } from '../template';
import { DepartmentManager } from './department';
import { Lane } from './lane';
import { Preference } from './prefrences';
import { Shift } from './shift';
import { Team, TeamUser } from './team';

export class StoreViewModel {
  public id: string;
  public dealershipName: string;
  public accountJson?: AccountJson | null;
  public isEnabled?: boolean;
}
export interface AccountJson {
  cit: CIT | null;
  ar: AR | null;
}
export class AccountNumbersList {
  public accountNumber?: string;
}
export interface CIT {
  accountNumber: string[];
}
export interface AR {
  accountNumber: string[];
}
export interface Store {
  id?: number;
  tenantId?: number;
  enterpriseId?: number;
  activeFlag?: boolean;
  accountNumber?: string;
  dealershipName?: string;
  storeId?: string;
  logo?: string;
  logoExt?: string;
  paymentProcessing?: boolean;
  mainDealershipPhone?: string;
  serviceDeptPhone?: string;
  disclaimers?: string;
  websiteURL?: string;
  terms?: string;
  additionalText?: string;
  merchantEmail?: string;
  allowOpenROForCustomer?: boolean;
  allowClosedROForCustomer?: boolean;
  allowPaymentOnlineForCustomer?: boolean;
  messagingNumber?: string;
  addressId?: number;
  isMessagingEnabled?: boolean;
  isStoreTeamEnabled?: boolean;
  glCompanyId?: any;
  timeZone?: string;
  defaultPaymentProvider?: string;
  isCenposConfigured?: boolean;
  isSquareConfigured?: boolean;
  isCloverConfigured?: boolean;
  isVantivConfigured?: boolean;
  isPayrocConfigured?: boolean;
  address?: Address;
  attachmentTypes?: AttachmentType[];
  dealFetchDays?: number;
  arStatementEmailFrom?: string;
  storeFeatures?: number[];
  templates?: Template[];
}
export interface Address {
  id?: string;
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  state: string;
  zip: string;
}

export interface VantivAccount {
  type?: string;
  typeDesc?: string;
  accountId?: string;
  acceptorId?: string;
  accountToken?: string;
  applicationId?: string;
  applicationName?: string;
  applicationVersion?: string;
  authorization?: string;
  expressXmlEndpoint?: string;
  hostedPaymentEndpoint?: string;
  laneUrl?: string;
  saleUrl?: string;
}

export interface CenposAccount {
  id?: string;
  merchantId?: string;
  merchantIdEncoded?: string;
  secretKey?: string;
  paymentURL?: string;
}

export interface SquareAccount {
  applicationId?: string;
  accessToken?: string;
  environment?: string;
}
export interface PayrocAccount {
  apiKey?: string;
  manualTerminalId?: string;
}
export interface AuthorizeNetAccount {
  apiLoginId?: string;
  transactionKey?: string;
}
export interface RedrockAccount {
  hostedFieldCdnUri?: string;
  username?: string;
  password?: string;
  hostedFieldKey?: string;
  uri?: string;
}
export interface CloverAccount {
  paymentBaseUrl?: string;
  merchantId?: string;
  accessToken?: string;
  publicToken?: string;
  privateToken?: string;
  environment?: string;
}

export interface Timing {
  id?: string;
  startTime?: string;
  endTime?: string;
  days?: string;
  timingTypeId?: number;
  storeId?: number;
  store?: Store;
  from?: string;
  to?: string;
}

export interface InvoiceConfig {
  id?: string;
  key?: string;
  value?: any;
}

export interface Pdi {
  id?: string;
  vehicleType?: number;
  laborOpCode?: string;
  serviceLineNumber?: number;
  lineType?: string;
  transCode?: string;
  serviceType?: string;
  sequenceNumber?: number;
  store?: Store;
}
export interface VehicleLocation {
  id?: string;
  locationName?: string;
  storeId?: number;
  storeName?: string;
  isDefault?: boolean;
}
export interface PdiJson {
  new?: Pdi[];
  used?: Pdi[];
  cpo?: Pdi[];
  dealertrade?: Pdi[];
}

export interface StoreModel {
  id?: number;
  enterpriseId?: number;
  storeJson?: StoreJson;
  paymentProcessorJson?: PaymentProcessor;
  dealAccountInfoJson?: DealAccountInfo;
  managerJson?: DepartmentManager[];
  featureJson?: FeatureAssignement[];
  laneJson?: Lane[];
  overrideTemplateJson?: Template[];
  preferenceJson?: Preference[];
  shiftJson?: Shift[];
  timingJson?: Timing[];
  teamJson?: Team[];
  invoiceConfigs?: InvoiceConfig[];
  shipmentProviderJson?: ShipmentProvider;
  storeconfig?: StoreConfig;
  attachments?: any[];
}
export interface StoreJson {
  name: string;
  glStoreId: string;
  glCompanyId: string;
  logoUri: string;
  introVideoUri: string;
  mainPhone: string;
  merchantEmail: string;
  vehicleStockedEmail: string;
  servicePhone: string;
  status: string;
  timeZone: string;
  websiteUrl: string;
  eccClearingAccountNumber: string;
  eccClearingControlNumber: string;
  dealArAccount: string;
  dealArControl: string;
  depositLogAccount: string;
  depositLogControl: string;
  lastReceiptNumber: string;
  vendorPaymentApiKey: string;
  vendorPaymentBankAccount: string;
  checkbookApiKey: string;
  checkbookApiSecret: string;
  checkbookWebhookKey: string;
  checkbookPaymentBankAccount: string;
  checkbookApiUrl: string;
  address: Address;
  pdiJson?: PdiJson;
  vehicleLocations?: VehicleLocation[];
  faxLines?: FaxLine[];
  crossCompanyPostingConfigs?: CrossCompanyPostingConfig[];
  readEmailConfig?: ReadEmailConfig[];
  checkbookBankAccountJson?: CheckbookBankAccountJson;
  franchiseCode: string;
  mainPhonePrefix?: string;
  servicePhonePrefix?: string;
  vehicleRegReviveStepNew?: string;
  vehicleRegReviveStepUsed?: string;
  vehicleInspectionReviveStepNew?: string;
  vehicleInspectionReviveStepUsed?: string;
  defaultPaymentProvider?: string;
  defaultLetterProvider?: string;
  lobPublishKey?: string;
  lobSecretkey?: string;
  defaultFaxProvider?: string;
  stockNumberLogic?: string;
  vinDigitCount?: number;
  stockPreAppendValue?: string;
  evStockPreAppendValue?: string;
  stockSequenceNumber?: string;
  vehicleInvoiceLocation?: string;
  creditCardBankAccount?: string;
  creditCardFees?: string;
  reconcilationDocNumber?: string;
  roDeductibleDocNumber?: string;
  vehicleDocumentNumber?: number;
  uberConfig?: UberConfig;
  allowPartReceiveByPacketSize?: boolean;
  isEnabled: boolean;
  rampClientId: string;
  rampClientSecret: string;
  defaultCardProvider?: string;
  cardControlNumber?: string;
  flooringReportUsersEmail?: any[];
  storeKey: string;
  vendorDefaultPaymentProvider?: string;
  repayCustomerId?: string;
  repayGroupName?: string;
  repayGroupAmountLimit?: string;
  ocrApiKey?: string;
  ocrUri?: string;
  apInvoiceProjectId?: string;
  vehicleProjectId?: string;
  payrocConfigEnvironment?: string;
}

export interface PaymentProcessor {
  Vantiv?: VantivAccount;
}
export interface DealAccountInfo {
  arAccountNumbers?: string[];
  citAccountNumbers?: string[];
}
export interface DepartmentManagers {
  id?: string;
  managers?: DepartmentManager[];
}
export interface FeatureAssignement {
  featureId: number;
  key: string;
  status: string;
}

export interface GetStoreList {
  id: string;
  dealershipName: string;
}

export interface EnterpriseEnvironment {
  blobUrl?: string;
  tenantId?: number;
  enterpriseId?: number;
  storeId?: number;
}
export interface AvailabilityViewModel {
  alternateUserName?: string;
  availabilityStatus?: string;
  storeId?: number;
  storeName?: string;
}
export interface AvailabilityEditViewModel {
  storeName?: string;
  storeId?: any;
  availabilityStatusId?: number;
  shiftId?: number;
  alternateUserId?: string;
  alternatePhoneNumber?: string;
  userId?: string;
}
export interface AvailabilityStatus {
  id?: string;
  status?: string;
}

export interface FaxLine {
  id: string;
  faxNumber: string;
  assignedUsers: string[];
}

export interface ForwardingNumber {
  id: string;
  name: string;
  alynkNumber: string;
  forwardingNumber: string;
}

export interface TaxCalculation {
  id: string;
  taxName: string;
  taxRate: string;
  taxPayableAccount: string;
}

export interface SIPTrunkNumber {
  id: string;
  name: string;
  trunkId: string;
}

export interface PositivePaySetup {
  id: string;
  bankAccountNumber: string;
  dmsBankAccountNumber: string;
}

export interface CustomReportSetup {
  id: string;
  accountNumber: string;
}

export interface TechClassSetup {
  id: string;
  techClass: string;
}

export interface TechClassChildSetup {
  id: string;
  techTime: number;
  greenStatusMinHours: number;
  yellowStatusMinHours: number;
  redStatusMinHours: number;
}

export interface ShippingAddress {
  id?: string;
  name?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
}
export interface ShipmentProvider {
  fedEx?: FedEx;
}
export interface FedEx {
  key?: string;
  password?: string;
  accountNumber?: string;
  meterNumber?: string;
  uri?: string;
}
export class StoreConfig {
  public expenseReminderTimeInterval?: number;
  public expenseVendorScheduleMailTime?: string;
  public poFailedSyncJobTime?: number;
  public poFailedSyncMinTime?: number;
  public vehicleDaysToSync?: number;
  public appoinmentMessageReminderSync?: string;
  public chargeCustomerSchedulerTime?: string;
  public appointmentResponseValidHours?: number;
  public partSalesDelayMinutes?: number;
  public isPartSalesSyncEnabled?: boolean;

  public weOweServiceContractBORecordKey?: string;
  public weOweDealFeeRecordType?: string;
  public weOweDealFeeSequenceNumber?: string;
}
export interface CrossCompanyPostingConfig {
  id?: string;
  arAccount?: string;
  apAccount?: string;
  arControl?: string;
  apControl?: string;
  storeId?: any;
  storeName?: string;
  selectedStoreId?: any;
}
export interface ReadEmailConfig {
  id?: string;
  host?: string;
  port?: number;
  ssl?: boolean;
  userName?: string;
  password?: string;
  hostProtocol?: string;
  emailType?: string;
  storeId?: any;
  storeName?: string;
  selectedStoreId?: any;
  isEmailSyncEnabled?: boolean;
  destinationPath?: string;
}
export interface CheckbookBankAccountJson {
  storeId?: number;
  id?: string;
  name?: string;
  date?: string;
  routing?: string;
  account?: string;
  status?: string;
  billing?: boolean;
  default?: boolean;
  type?: string;
}
export class UberConfig {
  public clientId?: string;
  public clientSecretKey?: string;
  public baseUrl?: string;
  public baseLoginUrl?: string;
  public ubserStoreId?: string;
  public placeProvider?: string;
  public scope?: string;
  public googleApiKey?: string;
  public uberInstructions?: string;
}

export class ChatGptInstruction {
  public id?: string;
  public storeId?: number;
  public template?: string;
}

export interface TechClassChildSetup {
  id: string;
  techTime: number;
  greenStatusMinHours: number;
  yellowStatusMinHours: number;
  redStatusMinHours: number;
}

export interface AddDeparment {
  enterPriseId: number;
  name: string;
  description: string;
}
